import React from 'react';
import CompetitionsBoard from '../components/Competitions/CompetitionsBoard';

/* /student/competitions: monthly challenges (send a project, see the winners) */
const StudentCompetitions = () => <CompetitionsBoard mode="student" />;

export default StudentCompetitions;
